import BrowserDetection from "../../app/util/BrowserDetection";
import AgentInfoDto from "../antrag/AgentInfoDto";
import BackendService from "../common/BackendService";
import FormulardatenViewDto from "../form/dto/FormulardatenViewDto";
import StvKampagne from "./dto/StvKampagne";
import VermittlerDto from "./dto/VermittlerDto";

const initAppData = () => {
    const params = {};
    return BackendService.getData("rest/op/init/app/data", params)
        .then(root => {
            const vermittler: VermittlerDto = root.vermittler;
            const formulardaten: FormulardatenViewDto = root.formulardaten;
            const vertragLaufzeitJahre: number = root.vertragLaufzeitJahre;
            const partnernrVorh: boolean = root.partnernrVorh;
            const kampagne: StvKampagne = root.kampagne
            return { vermittler, formulardaten, vertragLaufzeitJahre, partnernrVorh, kampagne };
        })
        .catch(error => {
            // TODO Fuest logging
            throw error;
        });
};

const initAppSession = (jwt?: string) => {

    //    tarifierung monatlich error 
    //    hier wird nicht gelogged
    //    init app mit Browserdaten

    const agentInfo = BrowserDetection.createUserAgentInfo();
    const agentInfoDto = new AgentInfoDto(agentInfo);

    const data = {
        agentInfo: agentInfoDto
    };

    return BackendService.postData("rest/session/init", { jwt }, data)
        .then(rootUiSessionId => {
            return rootUiSessionId;
        }).catch(error => {
            // TODO Fuest logging
            throw error;
        });
}

const AppInitConsumer = {
    initAppData,
    initAppSession
}

export default AppInitConsumer;